import { IntelliDocSuiteHome } from "../components/organisms/IntelliDocSuiteHome";

export const HomePage = () => <IntelliDocSuiteHome />;
